import React from 'react';
import { Card } from '../ui/Card';
type MetricCardProps = {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  subtitle?: string;
};
export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  icon,
  subtitle
}) => {
  return <Card data-id="element-269">
      <div className="flex justify-between items-start" data-id="element-270">
        <div data-id="element-271">
          <p className="text-sm font-medium text-gray-500" data-id="element-272">{title}</p>
          <h3 className="text-2xl font-bold text-navy mt-1" data-id="element-273">{value}</h3>
          {subtitle && <p className="text-xs mt-1 text-gray-500" data-id="element-274">{subtitle}</p>}
        </div>
        <div className="p-2 rounded-full bg-primary/10 text-primary" data-id="element-275">
          {icon}
        </div>
      </div>
    </Card>;
};